import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '2.725 16.8599'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M5.45 0.0998535H0C1.32 15.2899 0.169998 33.6199 0.169998 33.6199H5.28999C5.28999 33.6199 4.13 15.2899 5.45 0.0998535Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="2.7283"
            y1="4.94126"
            x2="2.7283"
            y2="34.6668"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity=".1" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
